import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import {Button, TextField} from "@mui/material";
import {useEffect, useRef, useState} from "react";
import {ArrowUpward, CheckCircle} from "@mui/icons-material";
import Box from "@mui/material/Box";
import useInterventionRepository from "../../../../../../repository/insurance/useInterventionRepository";
import Intervention from "../../../../../../entity/insurance/Intervention";
import parameter from "../../../../../../enum/parameter";
import NotifyOptional from "./NotifyOptional";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";

export default function ({interventionId}) {
    const eventDispatcher = useEventDispatcher();
    const interventionRepository = useInterventionRepository();
    const [loading, setLoading] = useState(false);
    const reservesInput = useRef();
    const reservesRef = useRef();

    useEffect(() => {
        eventDispatcher.launcher("reserves");
    }, []);

    const nextStep = async () => {
        setLoading(true);

        const res = await interventionRepository.updateCurrentStep(interventionId, {
            intervention: {
                current_step: Intervention.STEP_REPORT_COMPLETION,
                reservations: reservesInput.current.value.length > 0 ? reservesInput.current.value : null
            }
        });

        if (!res) setLoading(false);
    }

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyOptional/>
                </Box>
                <Box px={2} mt={5}>
                    <TextField
                        fullWidth
                        label={"Réserves émises par le sociétaire"}
                        multiline
                        rows={4}
                        inputRef={reservesInput}
                        ref={reservesRef}
                        data-test="insurance-input-beneficiary-reservation"
                    />
                    <PopperWrapper
                        elementRef={reservesRef}
                        placement={"bottom"}
                        content={"Si le sociétaire émet des réserves, complétez ce champ"}
                        triggeringEvent={"reserves"}
                        autoCloseAfter={parameter.POPUP_TIME}
                        displayCloseButton={false}
                        contentColor={parameter.POPUP_COLOR}
                        icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                    />
                </Box>
            </Body>
            <Footer>
                <Button
                    variant="contained"
                    size="small"
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    fullWidth
                    onClick={nextStep}
                    disabled={loading}
                    data-test="insurance-button-next-step"
                >
                    Envoyer le SMS
                </Button>
            </Footer>
        </>
    );
}
